import { defineComponent as _defineComponent } from 'vue'
import { Loading } from '@/ui/components/Loading';
  import { onBeforeUnmount, onMounted } from 'vue';
  import { Box } from '@/ui/components/Box';
  import { storeToRefs } from 'pinia';
  import { useCourseTakeStore } from '@/stores/trainings/courseTake';
  import CourseTakeButtons from '@/ui/components/trainings/courseTake/CourseTakeButtons.vue';
  import CourseTakeNavbar from '@/ui/components/trainings/courseTake/CourseTakeNavbar.vue';
  import ActiveItem from '@/ui/components/trainings/courseTake/ActiveItem.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseTakePage',
  props: {
    id: { type: Number, required: true },
  },
  setup(__props) {

const props = __props;

  

  const courseTake = useCourseTakeStore();
  const { course, isLoading } = storeToRefs(courseTake);

  onMounted(() => {
    courseTake.fetch(props.id);
  });

  onBeforeUnmount(() => {
    courseTake.$reset();
  });

return { __sfc: true,props, courseTake, course, isLoading, Loading, Box, CourseTakeButtons, CourseTakeNavbar, ActiveItem }
}

})